<ngx-spinner></ngx-spinner>
<!-- <app-header></app-header> -->
<section class="promotional_sect login-page">
  <a routerLink="" class="cross-icon">
    <span class="icon-close"></span>
  </a>
  <div class="content_sect">
    <div class="content_text">
      <div class="content_box">
        <div class="left-content">
          <img src="assets/images/logo-white.svg" />
          <div class="login-info">
            <h2 class="mb-2 font-bold">Welcome to Intelligens</h2>
            <h4 class="mb-2 font-bold">
              Stream real shows. Real shows that matter
            </h4>
            <h6 class="content-desk mb-3">
              This is your new home for reality shows with no scripts and
              documentaries with no filters. At Intelligens, we are dedicated to
              bringing you content that is not only entertaining but will also
              offer you a look into worlds you didn't even know existed. Join us
              today and become a part of the Intelligens family.
            </h6>
            <a routerLink="/signup" href="javascript:void(0)" class="btn btn-theme text-capitalize">{{
              "LOGIN_INFO.SIGN_UP" | translate }}
            </a>
          </div>
        </div>
        <div class="right-login">
          <div class="w-100">
            <div class="login">
              <div class="login-head">
                <h2>Login</h2>
                <div class="form-group social-login text-center">
                  <!-- <p>{{ "LOGIN_INFO.OR_CONNECT_USING" | translate }}</p> -->
                  <div class="d-flex justify-content-center">
                    <button class="btn login-with-facebook" (click)="signInWithFB()">
                      <span class="material-icons">facebook</span>
                    </button>
                    <button class="btn login-with-google" (click)="signInWithGoogle()">
                      <span class="icon-google-plus"></span>
                    </button>
                  </div>
                </div>
              </div>
              <form (ngSubmit)="login(loginForm.valid)" #loginForm="ngForm">

                <div class="position-relative form-group">
                  <div class="field-icon">
                    <span class="mdi mdi-email-outline"></span>
                  </div>
                  <input #mail type="email" [(ngModel)]="model.email" class="form-control with-icon-field login-fields"
                    placeholder="{{ 'LOGIN_INFO.EMAIL_PLACEHOLDER' | translate }}" #email="ngModel" name="email"
                    required maxlength="255" />
                  <div style="color: red" class="validation_div"
                    *ngIf="email.errors && (email.dirty || loginForm.submitted)">
                    <p class="mb-0" *ngIf="email.errors.required">
                      {{ "LOGIN_INFO.EMAIL_REQUIRED" | translate }}
                    </p>
                  </div>
                </div>
                <div class="form-group position-relative password-in">
                  <div class="field-icon">
                    <span class="mdi mdi-lock-open-outline"></span>
                  </div>
                  <div class="pass-ic">
                    <span class="icon-eye-closed" (click)="changePasswordType()" [ngClass]="{
                        'icon-eye-closed': passwordType == 'password',
                        'icon-eye-icon': passwordType != 'password'
                      }"></span>
                  </div>
                  <input maxlength="30" type="{{ passwordType }}" [(ngModel)]="model.password" class="
                      form-control
                      text-fields-gray
                      with-icon-field
                      password-fields
                    " placeholder="{{
                      'LOGIN_INFO.PASSWORD_PLACEHOLDER' | translate
                    }}" #password="ngModel" name="password" required />
                  <div style="color: red" class="validation_div" *ngIf="
                      password.errors && (password.dirty || loginForm.submitted)
                    ">
                    <p class="mb-0" *ngIf="password.errors.required">
                      {{ "LOGIN_INFO.PASSWORD_REQUIRED" | translate }}
                    </p>
                  </div>
                </div>
                <div class="
                    mb-4
                    pt-3
                    form-group
                    d-flex
                    justify-content-between
                    w-100
                  ">
                  <div class="custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck" [(ngModel)]="model.remember_me"
                      name="example1" />
                    <label class="custom-control-label text-white font-weight-light" for="customCheck">
                      {{ "LOGIN_INFO.REMEMBER_ME" | translate }}</label>
                  </div>

                  <div>
                    <a routerLink="/forgot-password" href="javascript:void(0)">{{
                      "LOGIN_INFO.FORGOT_PASSWORD" | translate
                      }}</a>
                  </div>
                </div>
                <div class="
                    form-group
                    d-flex
                    align-items-center
                    justify-content-center
                    mb-0
                  ">
                  <button class="btn btn-theme btn-login">
                    <span class="spin icon-loader" *ngIf="isLoading"> </span>
                    {{ "LOGIN_INFO.LOGIN" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>